var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2948 11.1303C15.1104 11.1319 19.0637 11.1077 19.0799 11.0766C19.1361 10.9686 18.9096 10.3481 18.663 9.93467C18.4243 9.53421 18.2848 9.38947 14.8197 5.94614L11.2241 2.37318L11.8219 1.77539L12.4197 1.17759L15.763 4.45799C19.1899 7.82046 19.6665 8.32547 20.1202 9.07473C21.145 10.7674 21.1852 13.0294 20.2211 14.7549C19.8182 15.4759 19.4434 15.877 15.8982 19.3805L12.4614 22.7767L11.8639 22.1792L11.2664 21.5818L14.6753 18.1999C18.5203 14.3856 18.6925 14.1947 18.9525 13.4604C19.0414 13.2093 19.0962 12.9634 19.0742 12.914C19.046 12.8509 16.4297 12.824 10.2855 12.8234L1.5368 12.8227L1.53523 11.9778C1.53439 11.5131 1.53489 11.1316 1.53646 11.13C1.53798 11.1285 5.47929 11.1286 10.2948 11.1303Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrow-right-black.1d30afab15be1a2c09a6c637f9e371e9.svg";
export { ForwardRef as ReactComponent };